const boxTypes = [    
    {
        id: 'necessito',
        description: "Necessito"
    },
    {
        id: 'puc',
        description: "Ofereixo"
    }
]

export { boxTypes }


// WEBPACK FOOTER //
// ./src/services/type.service.js